import type React from 'react';
import type { EntityT } from '@/features/EntityShow/types';
import Like from '@/features/Like/Like';
import Prices from '@/shared/Prices';

import styles from './styles.module.css';

type InfoEntity = {
  entity: EntityT;
};

const InfoMobileEntity: React.FC<InfoEntity> = ({ entity }) => {
  return (
    <div className={styles.infoEntityWrap}>
      <div className={styles.mainPrice}>
        <Prices
          price={entity.price}
          priceMeter={entity.price_meter}
          totalArea={entity.total_area}
          size="small"
        />

        <Like entity_id={entity.id} className={styles.like} />
      </div>
      <div className={styles.address}>{entity.full_address}</div>
    </div>
  );
};

export default InfoMobileEntity;
